import { FC } from 'react';
// components
import BottlePriceComponent from 'components/main/BottlePrice/Edit';

const EdiBottlePrice: FC = () => <BottlePriceComponent />;

export default EdiBottlePrice;
